import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/components/Dialog';
import { PillButton } from '@/shared/components/PillButton';
import { coinImg as coinIcon } from '@/assets';

export interface InsufficientPointsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  currentPoints: number;
}

export const InsufficientPointsDialog = memo(function InsufficientPointsDialog({
  isOpen,
  onClose,
  currentPoints
}: InsufficientPointsDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      variant="red"
      title={t('errors.insufficientPoints')}
      allowClickOutsideToClose={true}
    >
      <div className="space-y-4">
        {/* Balance info - white text with black border like title */}
        <p
          className="font-mind-boggle text-2xl text-white text-center leading-tight flex items-center justify-center gap-2"
          style={{
            textShadow:
              '3px 3px 0px #000, -1px -1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, 2px 2px 6px rgba(0,0,0,0.5)'
          }}
        >
          {t('common.currentBalance')} {currentPoints.toLocaleString()}
          <img src={coinIcon} alt="" className="w-6 h-6 object-contain" />
        </p>

        {/* Action button */}
        <PillButton
          variant="red"
          onClick={onClose}
          className="w-full h-12"
          icon={
            <span
              className="font-mind-boggle text-2xl text-white text-center leading-tight"
              style={{
                textShadow:
                  '3px 3px 0px #000, -1px -1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, 2px 2px 6px rgba(0,0,0,0.5)'
              }}
            >
              {t('common.ok')}
            </span>
          }
        />
      </div>
    </Dialog>
  );
});

export default InsufficientPointsDialog;
